import React from 'react'
import CatagoryWidget from "../../blog/CatagoryWidget";
import BannerWidget from "../../blog/BannerWidget";
import BlogDetailsContent6 from "../Modalitatideafirmare/BlogDetailsContent6";


function BlogDetailsWrap6() {
  return (
    <>
      <div className="blog-details-area sec-mar-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <BlogDetailsContent6 />
            </div>
            <div className="col-lg-4">
              <CatagoryWidget />
              <BannerWidget />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BlogDetailsWrap6